"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
/**
 * Form is a especial form that allow users to send requests and save data to the server in a easy and simple way
 * @param props
 */
var Form = function (props) { return (react_1.default.createElement(formik_1.Formik, __assign({}, props), function (formikProps) { return (react_1.default.createElement(formik_1.Form, { noValidate: true }, props.children instanceof Function ? props.children(formikProps) : props.children)); })); };
exports.default = Form;
//# sourceMappingURL=Form.js.map